import { extractArrayFromQuery } from '../../../utils/query';

export default {
  param: extractArrayFromQuery,
  having: function (values) {
    if (values.length > 0) {
      return {
        instruction: values[0] === 1 ? 'Led by partner' : 'Provided to the teacher to share'
        // "id": {
        //   [`$includes_any`]: {
        //     "offers.instruction": instructions
        //   }
        // }
      }
    }
  }
}
